<template>
    <div class="login-form-content">
        <div class="login-app-logo"></div>
    </div>
</template>
